import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b6b1ed40")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_q_resize_observer = _resolveComponent("q-resize-observer")
  const _component_fullscreen_image = _resolveComponent("fullscreen-image")

  return (_openBlock(), _createBlock("div", {
    class: ["message-img-wrapper", { '--is-widget': _ctx.isWidget }]
  }, [
    _createVNode("div", {
      class: "image-wrap",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isFull = true))
    }, [
      _createVNode("img", {
        src: _ctx.src,
        alt: "image",
        onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadedImage(...args)))
      }, null, 40, ["src"]),
      _createVNode(_component_q_resize_observer, { onResize: _ctx.onResize }, null, 8, ["onResize"])
    ]),
    _createVNode(_component_fullscreen_image, {
      modelValue: _ctx.isFull,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isFull = $event)),
      src: _ctx.src
    }, null, 8, ["modelValue", "src"])
  ], 2))
})